<template>
    <div class="total-block">
        <div class="padding-line"></div>
        <div class="title-line">
            <span class="sk-title-small">{{ title }}</span>
        </div>
        <div class="number-line">
            <span class="sk-number-total">{{ d }}</span>
        </div>
        <div class="data-line" v-if="showDS1">
            <div>{{ dimension1 }}</div>
            <div>
                <div class="right">
                    <span class="sk-number-up" v-if="convertNumber(d) > convertNumber(d1)">↑</span>
                    <span class="sk-number-down" v-if="convertNumber(d) < convertNumber(d1)">↓</span>
                </div>
                <div class="right">
                    <span class="sk-number-up" v-if="convertNumber(d) > convertNumber(d1)" :title="d1">{{ getData(d1) }}</span>
                    <span class="sk-number-down" v-else-if="convertNumber(d) < convertNumber(d1)" :title="d1">{{ getData(d1) }}</span>
                    <span v-else :title="d1">{{ getData(d1) }}</span>
                </div>
            </div>
        </div>
        <div class="data-line" v-if="showDS2">
            <div>{{ dimension2 }}</div>
            <div>
                <div class="right">
                    <span class="sk-number-up" v-if="convertNumber(d) > convertNumber(d2)">↑</span>
                    <span class="sk-number-down" v-if="convertNumber(d) < convertNumber(d2)">↓</span>
                </div>
                <div class="right">
                    <span class="sk-number-up" v-if="convertNumber(d) > convertNumber(d2)" :title="d2">{{ getData(d2) }}</span>
                    <span class="sk-number-down" v-else-if="convertNumber(d) < convertNumber(d2)" :title="d2">{{ getData(d2) }}</span>
                    <span v-else :title="d2">{{ getData(d2) }}</span>
                </div>
            </div>
        </div>
        <div class="data-line" v-if="showDS3">
            <div>{{ dimension3 }}</div>
            <div>
                <div class="right">
                    <span class="sk-number-up" v-if="convertNumber(d) > convertNumber(d3)">↑</span>
                    <span class="sk-number-down" v-if="convertNumber(d) < convertNumber(d3)">↓</span>
                </div>
                <div class="right">
                    <span class="sk-number-up" v-if="convertNumber(d) > convertNumber(d3)" :title="d3">{{ getData(d3) }}</span>
                    <span class="sk-number-down" v-else-if="convertNumber(d) < convertNumber(d3)" :title="d3">{{ getData(d3) }}</span>
                    <span v-else :title="d3">{{ getData(d3) }}</span>
                </div>
            </div>
        </div>
        <div class="padding-line"></div>
    </div>
</template>
<script>
/* 单个统计数字组件 */
export default {
    name: "TotalBlock",
    props: {
        title: { type: String },
        dimension1: { type: String, default: "较上日" },
        dimension2: { type: String, default: "较上周同日" },
        dimension3: { type: String, default: "较历史平均" },
        showDS1: { type: Boolean, default: true },
        showDS2: { type: Boolean, default: true },
        showDS3: { type: Boolean, default: true },
        data: {
            type: Object,
        },
        dec: {
            type: Number,
            default: 2,
        },
    },
    computed: {
        d() {
            return this.getNumber("d", this.dec);
        },
        d1() {
            return this.getNumber("d1", 1);
        },
        d2() {
            return this.getNumber("d2", 1);
        },
        d3() {
            return this.getNumber("d3", 1);
        },
    },
    methods: {
        getNumber(key, dec) {
            let v = 0;
            if (this.data[key]) {
                v = this.convertNumber(this.data[key]);
            }
            return v.format(dec);
        },
        getData(dn) {
            let f1 = this.convertNumber(this.d);
            let f2 = this.convertNumber(dn);
            if (f1 == f2 || f2 == 0) {
                return "0%";
            } else {
                return ((Math.abs(f1 - f2) * 100) / f2).format(1) + "%";
            }
        },
        convertNumber(s) {
            if (typeof s == "string") {
                var val = parseFloat(s.replace(/[^\d.-]/g, ""));
                if (isNaN(val)) {
                    return 0;
                }
                return val;
            }
            return s;
        },
    },
};
</script>
